import { useEffect, useMemo } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, { PaginationProvider }  from "react-bootstrap-table2-paginator";
import * as actions from "../../../_redux/system-logs/SystemLogsAction";
import * as uiHelpers from "../SystemLogsUIHelpers";
import {
  getHandlerTableChange,
  NoRecordsFoundMessage, 
  PleaseWaitMessage, 
  sortCaret
} from "../../../../../../_metronic/_helpers";
import * as columnFormatters from "./column-formatters";
import { Pagination } from "../../../../../../_metronic/_partials/controls";
import { useSystemLogsUIContext } from "../SystemLogsUIContext";

export function SystemLogsTable() {
  // System Logs UI Context
  const systemLogsUIContext = useSystemLogsUIContext();
  const systemLogsUIProps = useMemo(() => {
    return {
      queryParams: systemLogsUIContext.queryParams,
      setQueryParams: systemLogsUIContext.setQueryParams,
      openExceptionModal: systemLogsUIContext.openExceptionModal
    };
  }, [systemLogsUIContext]);

  // Getting curret state of System Logs list from store (Redux)
  const { currentState } = useSelector(
    (state) => ({ currentState: state.systemLogs }),
    shallowEqual
  );
  const { totalCount, entities, listLoading } = currentState;
  
  // System Logs Redux state
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(actions.getSystemLogs(systemLogsUIProps.queryParams));
    return () => dispatch(actions.cleanSystemLogsState());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [systemLogsUIProps.queryParams, dispatch]);

  // Table columns
  const columns = [
    {
      dataField: "schoolName",
      text: "Okul Adı",
      sort: true,
      sortCaret: sortCaret,
      style: {
        minWidth: "150px"
      }
    },
    {
      dataField: "userName",
      text: "Kullanıcı Adı",
      sort: true,
      sortCaret: sortCaret,
      style: {
        minWidth: "150px"
      }
    },
    {
      dataField: "userTypeName",
      text: "Kullanıcı Türü",
      sort: true,
      sortCaret: sortCaret,
      style: {
        minWidth: "150px"
      }
    },
    {
      dataField: "message",
      text: "Message",
      sort: true,
      sortCaret: sortCaret,
      style: {
        minWidth: "150px"
      }
    },
    {
      dataField: "messageTemplate",
      text: "Message Template",
      sort: true,
      sortCaret: sortCaret,
      style: {
        minWidth: "150px"
      }
    },
    {
      dataField: "level",
      text: "Level",
      sort: true,
      sortCaret: sortCaret,
      formatter: columnFormatters.LevelColumnFormatter,
      style: {
        minWidth: "150px"
      }
    },
    {
      dataField: "timestamp",
      text: "Tarih",
      sort: true,
      sortCaret: sortCaret,
      style: {
        minWidth: "120px"
      }
    },
    {
      dataField: "action",
      text: "İşlemler",
      formatter: columnFormatters.ActionsColumnFormatter,
      formatExtraData: {
        openExceptionModal: systemLogsUIProps.openExceptionModal
      },
      classes: "text-right pr-1",
      headerClasses: "text-right pr-0",
      style: {
        minWidth: "100px",
      }
    }
  ];

  // Table pagination properties
  const paginationOptions = {
    custom: true,
    totalSize: totalCount,
    sizePerPageList: uiHelpers.sizePerPageList,
    sizePerPage: systemLogsUIProps.queryParams.pageSize,
    page: systemLogsUIProps.queryParams.pageNumber
  };
  
  return (
    <PaginationProvider pagination={paginationFactory(paginationOptions)}>
      {({ paginationProps, paginationTableProps }) => {
        return (
          <Pagination
            isLoading={listLoading}
            paginationProps={paginationProps}
          >
            <BootstrapTable
              wrapperClasses="table-responsive"
              classes="table table-head-custom table-vertical-center overflow-hidden"
              bootstrap4
              bordered={false}
              remote
              keyField="id"
              data={entities ?? []}
              columns={columns}
              defaultSorted={uiHelpers.defaultSorted}
              onTableChange={getHandlerTableChange(
                systemLogsUIProps.setQueryParams
              )}
              {...paginationTableProps}
            >
              <PleaseWaitMessage entities={entities} />
              <NoRecordsFoundMessage entities={entities} />
            </BootstrapTable>
          </Pagination>
        );    
      }}
    </PaginationProvider>  
  );
}